import { render } from "./VabeneDeletedOrdersReport.vue?vue&type=template&id=52a42772&scoped=true&ts=true"
import script from "./VabeneDeletedOrdersReport.vue?vue&type=script&lang=ts"
export * from "./VabeneDeletedOrdersReport.vue?vue&type=script&lang=ts"

import "./VabeneDeletedOrdersReport.vue?vue&type=style&index=0&id=52a42772&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a42772"]])

export default __exports__